import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import {orderData} from '../reconciliation-requests'

import { updateNestedValue } from "../../../../../../common/services/common.service";
import { MdTableView } from "react-icons/md";
import { ReconciliationRequestPopup } from "../components/reconciliation-request-popup.component";
import { selectReconciliationRequestCreatedItem, selectReconciliationRequestDeletedItem, selectReconciliationRequestsListItems, selectReconciliationRequestUpdatedItem } from "../../../../../../redux/settlement-hub/reconciliation-requests/selector";
import { ReconciliationRequestItemsPopup } from "../../reconciliation-request-items/containers/reconciliation-request-items-popup";
import { reconciliationRequests } from "../../../../../../redux/settlement-hub/reconciliation-requests/action";
import { libraryData, TO_BE_INITIATED } from "../../constants/constants";

const ReconciliationRequests = ({
  
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showReconciliationRequestPopup, setShowReconciliationRequestPopup] = useState<boolean>(false);
  const [showReconciliationRequestItemsPopup, setShowReconciliationRequestItemsPopup] = useState<boolean>(false);
  const [selectedReconciliationRequest, setSelectedReconciliationRequest] = useState<any>({
    "Id": 0,
    "OrderId": 0,
    "CollectorAppId": "",
    "ReceiverAppId": "",
    "Amount": {
        "Currency": "INR",
        "Value": "0"
    },
    "ReconciliationRequestStatusId": TO_BE_INITIATED,
    "Remarks": ""
});

  const [listItems, setListItems] = useState<any>([]);
  const listOfReconciliationRequestsData = useSelector(selectReconciliationRequestsListItems)
  const createReconciliationRequestRequestsData = useSelector(selectReconciliationRequestCreatedItem)
  const updateReconciliationRequestRequestsData = useSelector(selectReconciliationRequestUpdatedItem)
  const deleteReconciliationRequestsRequestsData = useSelector(selectReconciliationRequestDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'OrderId', headerName: 'Order Id', sortable: true, filter: true, filterType: 'text', },
      { field: 'Amount.Value', headerName: 'Amount', sortable: true, filter: true, filterType: 'number', },
      { field: 'ReconciliationRequestStatusId', headerName: 'Status', sortable: true, filter: true, filterType: 'text', cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData, menuKey: 'Value', menuValue: 'Description', callback: handleStatus, anchorPosition: 'top-left' },
      },
      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'UpdatedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: '', headerName: 'Items', sortable: false, filter: false, cellRenderer: 'customFunctions'},

    ]);
  }

  const handleStatus = () => {

  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedReconciliationRequest, path, value', selectedReconciliationRequest, path, value)
    const updatedData = updateNestedValue(selectedReconciliationRequest, path, value)

    console.log('updatedData', updatedData)
    setSelectedReconciliationRequest({...updatedData});
  }

  const handleAddReconciliationRequest = () => {    
    setSelectedReconciliationRequest({
      "Id": 0,
      "OrderId": 0,
      "CollectorAppId": "",
      "ReceiverAppId": "",
      "Amount": {
          "Currency": "INR",
          "Value": "0"
      },
      "ReconciliationRequestStatusId": TO_BE_INITIATED,
      "Remarks": ""
  })
    setShowReconciliationRequestPopup(true)
  }

  const handleInitiateReconciliationRequest = () => {
    
  }

  const handleReconciliationRequest = () => {

  }

  const handleEdit = (data: any) => {
    setSelectedReconciliationRequest(data)
    setShowReconciliationRequestPopup(true)
  }

  const handleDelete = async (data: any) => {
    console.log('delete item', data)
    // const ids = _.map(data, (item: any) => {return {Id: item?.ReconciliationRequestRequest?.Id}})
    // console.log('ids',ids)
    await dispatch(reconciliationRequests.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-requests/delete`,
      entity: 'reconciliationRequests',
      jsonData: {
        Context:{},
        Records: [{Id: data?.ReconciliationRequestRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add ReconciliationRequest</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add ReconciliationRequest',
      callback: () => handleAddReconciliationRequest(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleReconciliationRequestItems =(item: any) => {
    setShowReconciliationRequestItemsPopup(true)
  }

  const customFunctions = [
    {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleReconciliationRequestItems, title: "Show ReconciliationRequest Items"},
    // {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSpecificationAttributeOptions, title: "Show Specification Attribute Options"},
  ];

  const handleReloadData = () => {
    listReconciliationRequests();
  }

  const listReconciliationRequests = async () => {
    console.log('reconciliationRequests')
    await dispatch(reconciliationRequests.resetAction({actionType:'list'}))
    await dispatch(reconciliationRequests.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-requests/list`,
      entity: 'reconciliationRequests',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSaveReconciliationRequest = async (selectedReconciliationRequest: any) => {
    if (selectedReconciliationRequest?.Id > 0) {
      await dispatch(reconciliationRequests.resetAction({actionType:'update'}))
      await dispatch(reconciliationRequests.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-requests`, entity: 'reconciliationRequests', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedReconciliationRequest
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(reconciliationRequests.resetAction({actionType:'update'}))
      await dispatch(reconciliationRequests.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-requests`, entity: 'reconciliationRequests', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedReconciliationRequest
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listReconciliationRequests();
  }

  const closeModal = () => {
    setShowReconciliationRequestPopup(false)
  }

  const closeItemsModal = () => {
    setShowReconciliationRequestItemsPopup(false)
  }

  useEffect(() => {
    console.log('listOfReconciliationRequestsData', listOfReconciliationRequestsData)
    // if(listOfReconciliationRequestsData?.isSuccess){
      if(listOfReconciliationRequestsData?.result?.items && listOfReconciliationRequestsData?.result?.items?.length > 0)
      {
        console.log('listOfReconciliationRequestsData?.result?.items[0].Error', listOfReconciliationRequestsData?.result?.items[0].Error)
        if (listOfReconciliationRequestsData?.result?.items[0].Error){
          setListItems(orderData)          
        }   
        else {
          setListItems(listOfReconciliationRequestsData?.result?.items)
        }     
      }  else {
        setListItems(orderData)
      }    
    // }
  }, [listOfReconciliationRequestsData]);

  // useEffect(() => {
  //   setListItems(orderData)
  // }, []);

  useEffect(() => {
    console.log('list items', listItems)
  
  }, [listItems]);

  useEffect(() => {
    listReconciliationRequests();
  }, [deleteReconciliationRequestsRequestsData]);

  useEffect(() => {
    createColumnDefs()
    listReconciliationRequests()
  }, [pageData, pageSize])

  return (
    <>
      {
        showReconciliationRequestPopup ?
          <ReconciliationRequestPopup
            selectedReconciliationRequest={selectedReconciliationRequest}
            closeModal={closeModal}
            handleSaveReconciliationRequest={handleSaveReconciliationRequest}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }
      {
        showReconciliationRequestItemsPopup ?
          <ReconciliationRequestItemsPopup
            selectedReconciliationRequest={selectedReconciliationRequest}
            closeModal={closeItemsModal}
            handleSaveReconciliationRequest={handleSaveReconciliationRequest}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }
      {listOfReconciliationRequestsData?.isLoading || deleteReconciliationRequestsRequestsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfReconciliationRequestsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          customFunctions={customFunctions}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }} 
          headingName="Reconciliation Requests" />
      }
    </>
  );
};

export default ReconciliationRequests;


